import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DataType } from '@etoh/database/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'etoh-link-renderer',
  template: `
    @if (cellValue) {
    <a [routerLink]="[route]">
      {{ cellValue }}
    </a>
    }
  `,
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class LinkComponent implements ICellRendererAngularComp {
  public cellValue: string;
  params!: ICellRendererParams;
  context: any;
  data: any;

  dataType: DataType;

  constructor() {}

  refresh(_params: ICellRendererParams<any, any>): boolean {
    return false;
  }
  agInit(params: ICellRendererParams): void {
    // console.log('params', params);
    this.cellValue = params.value;
    this.data = params.data;
    this.context = params.context;

    this.dataType = (params as any).dataType;
    if (!this.dataType) {
      console.error('Missing data type');
    }
  }

  get route() {
    return `/features/${this.dataType}/edit/${this.cellValue}`;
  }
}
